import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { AccountService } from '@services/account.service';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent {
  //userInformation
  userInformation!: any;
  //variable for validate form
  submitted: boolean = false;
  //error variable
  err:any;
  constructor(private router:Router,private account:AccountService) { }
  get name(){return this.userInformation.get('name'); }
  get email(){return this.userInformation.get('email'); }
  get password(){return this.userInformation.get('password'); }
  get confirmPassword(){return this.userInformation.get('confirmPassword'); }

  ngOnInit(): void {
    this.userInformation= new FormGroup({
      "name": new FormControl("", [Validators.required]),
      "email": new FormControl("", [Validators.required,Validators.email]),
      "password": new FormControl("", [Validators.required]),
      "confirmPassword": new FormControl("", [Validators.required]),

    })
  }
  adduser(){
    if (this.userInformation.valid && this.name.value != null && this.confirmPassword.value != null &&  this.email.value != null && this.password.value != null){
      this.submitted = true;
      this.account.register(this.userInformation.value).subscribe((result)=>{
        this.submitted = false;
        this.router.navigateByUrl('/emailvalidation');
      },
        (error)=>{
          this.err=error;
          this.submitted = false;
        }
      );
    } else{
      this.submitted = false;
      this.validateform(this.userInformation)
    }
  }


  private validateform(form: FormGroup ){
    Object.keys(form.controls).forEach(field =>{
      const controls =  form.get(field);
      if(controls instanceof FormControl){
        controls.markAsDirty({onlySelf: true});

      }else if(controls instanceof FormGroup){
        this.validateform(controls)
      }
    })

  }
}
